import React from 'react';
import { Link as RouterLink } from 'react-router-dom';
import {
  Breadcrumbs, Link, Typography, makeStyles, Box
} from '@material-ui/core';
import NavigateNextIcon from '@material-ui/icons/NavigateNext';

const useStyles = makeStyles((theme) => ({
  root: {},
  action: {
    marginBottom: theme.spacing(1),
    '& + &': {
      marginLeft: theme.spacing(1)
    }
  },
  actionIcon: {
    marginRight: theme.spacing(1)
  }
}));

interface Props {
    title: string,
    actions: React.ReactNode,
    breadcrumbs: Array<{
        title: string,
        route: string,
    }>,
}

function Header({ breadcrumbs, title, actions }: Props) {
  const crumbs = breadcrumbs.length ? (
    <Breadcrumbs separator={<NavigateNextIcon fontSize="small" />} aria-label="breadcrumb">
      {breadcrumbs.map((breadcrumb, idx) => (
        <Link variant="body1" color="inherit" to={breadcrumb.route} component={RouterLink}>
          {breadcrumb.title}
        </Link>
      ))}
      <Typography variant="body1" color="textPrimary">
        {title}
      </Typography>
    </Breadcrumbs>
  ) : null;

  return (
    <Box display="flex" justifyContent="space-between">
      <Box>
        {crumbs}
        <Typography variant="h3" color="textPrimary">
          {title}
        </Typography>
      </Box>
      <Box>
        {actions}
      </Box>
    </Box>
  );
}
Header.defaultProps = {
  breadcrumbs: [],
};
export default Header;
